import { _URL } from "../config.json";
import http from "./http";

const apiEndpoint = _URL + "/api/Upload/UploadTmpFile/";

export default function uploadTmpFile(obj) {
  let formData = new FormData();
  formData.append("file", obj);
  return http.post(apiEndpoint, formData);
}
